"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bucketedSumBy = void 0;
const aggregate_by_1 = require("./aggregate-by");
/**
 * Returns a Map of the sum of the values, retrieved by the retriever function, of each group/bucket.
 *
 *
 * ```ts
 * const list = [ {currency:'eur', amount:20}, {currency:'usd', amount:40} , {currency:'usd', amount:20}}];
 * const sumByCurrency = bucketedSumBy(list, 'currency', listItem => listItem.amount);
 * // sumByCurrency is a Map with the following entries: { eur: 20, usd: 60 }
 * ```
 *
 * @param list The list to group and sum.
 * @param bucket The bucket to group by.
 * @param retriever The function to retrieve the value which will be added to the sum.
 */
function bucketedSumBy(list, bucket, retriever) {
    return (0, aggregate_by_1.aggregateBy)(list, bucket, "sum", retriever);
}
exports.bucketedSumBy = bucketedSumBy;
//# sourceMappingURL=sum-by.js.map